import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CommonAppModule } from '../../common/common-app.module';
import { OperationWizardModule } from '../../common/operation-wizard/operation-wizard.module';
import { UiModule } from '../../ui/ui.module';

import { InsuranceCreateExternalWizardComponent } from './insurance-create-external-wizard/insurance-create-external-wizard.component';
import { InsuranceDetailComponent } from './insurance-detail/insurance-detail.component';
import { InsuranceSectionRoutingModule } from './insurance-section-routing.module';
import { InsuranceSectionComponent } from './insurance-section.component';
import { InsuranceSportCreateWizardComponent } from './insurance-sport-create-wizard-wizard/insurance-sport-create-wizard.component';
import { InsuranceSuggestionsComponent } from './insurance-suggestions/insurance-suggestions.component';
import { InsuranceVerticalMenuComponent } from './insurance-vertical-menu/insurance-vertical-menu.component';

@NgModule({
	imports: [
		CommonModule,
		CommonAppModule,
		RouterModule,
		UiModule,

		InsuranceSectionRoutingModule,
		OperationWizardModule,
	],
	declarations: [
		InsuranceSectionComponent,
		InsuranceSuggestionsComponent,
		InsuranceCreateExternalWizardComponent,
		InsuranceDetailComponent,
		InsuranceVerticalMenuComponent,
		InsuranceSportCreateWizardComponent,
	],
})
export class InsuranceSectionModule { }
